import { useEffect, useState } from 'react';

import { Button, Icon } from '@vestigas/ui';

type P = {
  readonly disabled: boolean;
  readonly file: File | undefined;
  readonly onClear: () => void;
  readonly removeLabel: string;
};

export function ScreenshotThumbnail({
  disabled,
  file,
  onClear,
  removeLabel,
}: P) {
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (!file) {
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
      setUrl('');
    };
  }, [file]);

  if (!file || !url) {
    return null;
  }

  return (
    <div className="relative">
      <img
        alt={file.name}
        className="w-full rounded border border-tiga-border-default object-cover"
        src={url}
        title={file.name}
      />
      <Button
        aria-label={removeLabel}
        className="absolute top-1 right-1 bg-white shadow-sm hover:bg-white"
        disabled={disabled}
        icon={<Icon metaphor="close" />}
        onClick={onClear}
      />
    </div>
  );
}
